import ScrollToTop from './modules/ScrollToTop'
import PageLoader from './modules/PageLoader'
import DivToggle from './modules/DivToggle'
//import ScrollAnimation from './modules/ScrollAnimation'

const scrolltotop = new ScrollToTop()
const pageLoader = new PageLoader()
const divToggle = new DivToggle()
//const scrollAnimation = new ScrollAnimation()

var swiper = new Swiper(".main-swiper", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

